module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 1407
// module chunks = 0